export const primary = {
  lighter: '#f3f1fb',
  light: '#ddd8f2',
  main: '#4c3f99',
  hover: '#43378a',
  dark: '#372f71',
  muted: '#6d62ae',
  contrast: '#ffffff'
} as const;

export const statusBlue = {
  light: '#dce7f7',
  border: '#a1beea',
  main: '#3e75c6',
  hover: '#1253b4',
  contrast: '#0c387a'
} as const;

export const statusGreen = {
  light: '#e5efe8',
  border: '#b8cfbf',
  main: '#628a6e',
  hover: '#547760',
  contrast: '#35513d'
} as const;

export const secondary = {
  light: '#e8f2b3',
  main: '#cad225',
  hover: '#bdc51e',
  contrast: '#606717'
} as const;

export const statusOrange = {
  light: '#fff0e6',
  border: '#f0b27a',
  main: '#e07030',
  hover: '#c75f22',
  contrast: '#d68454'
} as const;

export const statusYellow = {
  light: '#fff8e1',
  border: '#ffe082',
  main: '#ffd54f',
  hover: '#ffca28',
  contrast: '#d9a825'
} as const;
